export default __webpack_public_path__ + "static/media/icons.cf40639c.svg";